import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { useAuth } from '../auth/AuthContext';

const ProtectedRoute = ({ children, allow }) => {
  const auth = useAuth();
  const location = useLocation();

  if (auth.loading) {
    return (
      <Box sx={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}>
        <CircularProgress />
      </Box>
    );
  }

  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (auth.user?.mustChangePassword && location.pathname !== '/trocar-senha') {
    return <Navigate to="/trocar-senha" replace state={{ from: location }} />;
  }

  if (typeof allow === 'function' && !allow(auth.user)) {
    return <Navigate to="/pedidos" replace />;
  }

  return children;
};

export default ProtectedRoute;
